import React from "react"
import { useEffect } from "react"
import ReactModal from "react-modal"
import Clickable from "@components/clickable"
import styles from "./modal.module.scss"

export const toggleScroll = on => {
  const className = "is_scrollDisabled"
  const list = window.document.documentElement.classList
  if (on) {
    list.add(className)
  } else {
    list.remove(className)
  }
}

const Modal = React.memo(({ isOpen, children, ...props }) => {
  useEffect(() => {
    ReactModal.setAppElement("#___gatsby")
  }, [])

  useEffect(() => {
    toggleScroll(isOpen)
  }, [isOpen])

  return (
    <ReactModal {...props} isOpen={isOpen}>
      <Clickable
        className={styles.close}
        onClick={() => {
          if (props.onRequestClose) {
            props.onRequestClose()
          }
        }}
      >
        &times;
      </Clickable>
      <div className={styles.body}>{children}</div>
    </ReactModal>
  )
})

Modal.displayName = "Modal"
export default Modal
